import { render, staticRenderFns } from "./DoctorTestModal.vue?vue&type=template&id=68408216&scoped=true&"
import script from "./DoctorTestModal.vue?vue&type=script&lang=js&"
export * from "./DoctorTestModal.vue?vue&type=script&lang=js&"
import style0 from "./DoctorTestModal.vue?vue&type=style&index=0&id=68408216&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68408216",
  null
  
)

export default component.exports